<template>
  <div style="width: 100%">
    <v-card width="100%" class="ml-3 mr-3">
      <v-card-title>
        <v-btn
          fab
          text
          small
          color="grey darken-2"
          :disabled="currentDay === 0"
          @click="--currentDay"
        >
          <v-icon small>mdi-chevron-left</v-icon>
        </v-btn>
        {{ scheduleDays[currentDay] | formatDate }}
        <v-btn
          fab
          text
          small
          color="grey darken-2"
          :disabled="currentDay === Object.keys(schedule).length - 1"
          @click="++currentDay"
        >
          <v-icon small>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-window v-model="currentDay" vertical reverse>
        <v-window-item v-for="(dailySchedule, date) in schedule" :key="date">
          <v-list width="100%">
            <div v-for="(scheduleToday, index) in dailySchedule" :key="scheduleToday._id">
              <v-list-item
                v-if="!scheduleToday.children || scheduleToday.children.length === 0"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ scheduleToday.startTime | formatTime }} -
                    {{ scheduleToday.endTime | formatTime }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{
                      scheduleLocale === "en" && scheduleToday.title_en
                        ? scheduleToday.title_en
                        : scheduleToday.title
                    }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn color="primary" dark @click="showDetailView(scheduleToday)">
                    {{ $t("details") }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-list-group v-else>
                <template #activator>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ scheduleToday.startTime | formatTime }} -
                      {{ scheduleToday.endTime | formatTime }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{
                        scheduleLocale === "en" && scheduleToday.title_en
                          ? scheduleToday.title_en
                          : scheduleToday.title
                      }}
                    </v-list-item-subtitle>
                    <template v-if="scheduleToday.chairpersons">
                      <v-list-item-subtitle
                        v-for="chairperson in scheduleToday.chairpersons"
                        :key="chairperson.name"
                      >
                        {{ chairperson.name }} ({{ chairperson.company }})
                      </v-list-item-subtitle>
                    </template>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="childSchedule in scheduleToday.children"
                  :key="childSchedule._id"
                >
                  <v-list-item-content class="ml-2">
                    <v-list-item-title>
                      {{ childSchedule.startTime | formatTime }} -
                      {{ childSchedule.endTime | formatTime }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      v-html="
                        scheduleLocale === 'en' && childSchedule.title_en
                          ? childSchedule.title_en
                          : childSchedule.title
                      "
                    >
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      color="primary"
                      dark
                      @click="showDetailView(childSchedule)"
                      v-html="$t('details')"
                    >
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
              <v-divider v-if="index < dailySchedule.length - 1"></v-divider>
            </div>
          </v-list>
        </v-window-item>
      </v-window>
    </v-card>
    <v-dialog v-model="detailView" width="unset">
      <event-detail
        @close="detailView = false"
        :selectedEvent="selectedEvent"
      ></event-detail>
    </v-dialog>
  </div>
</template>

<script>
import { pageTypeResource } from "./../api/resources";
import { i18n } from "../plugins/i18n";
import * as moment from "moment";
import EventDetail from "./EventDetail.vue";

export default {
  components: {
    EventDetail,
  },
  props: ["events"],
  async mounted() {
    moment.locale(this.scheduleLocale);
    const pageType = (await pageTypeResource.get()).data.type;
    const scheduleMap = {};
    this.events.forEach((event) => {
      if (!scheduleMap.hasOwnProperty(event.date)) {
        scheduleMap[event.date] = [];
        this.scheduleDays.push(event.date);
      }
      scheduleMap[event.date].push(event);
    });
    for (let date in scheduleMap) {
      const dailyEvents = scheduleMap[date];
      const parentEvents = [];
      for (let i = 0; i < dailyEvents.length; ++i) {
        for (let j = i + 1; j < dailyEvents.length; ++j) {
          if (
            dailyEvents[i].startTime === dailyEvents[j].startTime &&
            pageType !== "ISRM"
          ) {
            const parentEvent =
              dailyEvents[i].endTime > dailyEvents[j].endTime
                ? dailyEvents[i]
                : dailyEvents[j];
            parentEvent.children = [];
            parentEvents.push(parentEvent);
          }
        }
      }
      let hierarchicalEvents = [];
      for (let i = 0; i < dailyEvents.length; ++i) {
        if (parentEvents.find((event) => event._id === dailyEvents[i]._id)) {
          hierarchicalEvents.push(dailyEvents[i]);
          continue;
        }
        let inserted = false;
        for (let j = 0; j < parentEvents.length; ++j) {
          if (
            dailyEvents[i].startTime >= parentEvents[j].startTime &&
            dailyEvents[i].endTime <= parentEvents[j].endTime
          ) {
            parentEvents[j].children.push(dailyEvents[i]);
            inserted = true;
            break;
          }
        }
        if (inserted) {
          continue;
        }
        hierarchicalEvents.push(dailyEvents[i]);
      }
      hierarchicalEvents.forEach((event) => {
        if (event.children) {
          event.children = event.children.sort((event1, event2) =>
            event1.startTime > event2.startTime
              ? 1
              : event2.startTime > event1.startTime
              ? -1
              : event1.title.localeCompare(event2.title)
          );
        }
      });
      scheduleMap[date] = hierarchicalEvents.sort((event1, event2) =>
        event1.startTime > event2.startTime
          ? 1
          : event2.startTime > event1.startTime
          ? -1
          : event1.title.localeCompare(event2.title)
      );
    }

    for (let date in scheduleMap) {
      let dailyEvents = scheduleMap[date];
      for (let i = dailyEvents.length - 1; i >= 0; --i) {
        if (dailyEvents[i].categoryId) {
          const endTime = dailyEvents[i].endTime;
          let startTime = dailyEvents[i].startTime;
          for (let j = i - 1; j >= 0; --j) {
            if (dailyEvents[j].categoryId === dailyEvents[i].categoryId) {
              if (dailyEvents[j].endTime === startTime) {
                startTime = dailyEvents[j].startTime;
              }
            }
          }
          const children = dailyEvents.filter(
            (event, index) =>
              index < i &&
              event.categoryId === dailyEvents[i].categoryId &&
              event.startTime >= startTime &&
              event.endTime <= endTime
          );
          dailyEvents[i] = {
            startTime: startTime,
            endTime: endTime,
            title: dailyEvents[i]._category.title,
            title_en: dailyEvents[i]._category.title_en,
            children: [...children, dailyEvents[i]],
            _category: dailyEvents[i]._category,
          };
          if (
            dailyEvents[i]._category.chairpersons &&
            dailyEvents[i]._category.chairpersons.length
          ) {
            dailyEvents[i].chairpersons = dailyEvents[i]._category.chairpersons;
          }
          children.forEach((child) => {
            dailyEvents.splice(dailyEvents.indexOf(child), 1);
            --i;
          });
        }
      }
      dailyEvents = dailyEvents.sort((event1, event2) =>
        event1.startTime > event2.startTime
          ? 1
          : event2.startTime > event1.startTime
          ? -1
          : event1.title.localeCompare(event2.title)
      );
    }

    this.schedule = scheduleMap;
    const today = moment().format("YYYY-MM-DD");
    const todayIndex = this.scheduleDays.findIndex((day) => day === today);
    this.currentDay = Math.max(todayIndex, 0);
  },
  data: () => ({
    currentDay: 0,
    schedule: {},
    scheduleDays: [],
    selectedEvent: {},
    detailView: false,
  }),
  computed: {
    scheduleLocale() {
      return i18n.locale;
    },
  },
  methods: {
    showDetailView(scheduleToday) {
      this.selectedEvent = scheduleToday;
      this.detailView = true;
    },
  },
};
</script>
